module.exports = __webpack_public_path__ + "img/sb09.32ba5e21.png";